import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Tailwind class merger - same `cn` helper shadcn-style components use. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
